var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"components__cnt-image"},_vm._l((_vm.contentItem.files),function(file){return _c('div',{key:file.id,staticClass:"single-image-container"},[_c('img',{attrs:{"src":file.url}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }